import { z } from "zod";

export const telemetryDataProviderSchema = z.enum(["FLESPI", "HIGH_MOBILITY"]);
export type TelemetryDataProvider = z.infer<typeof telemetryDataProviderSchema>;

export const telemetryConnectionStatusSchema = z.enum([
  "APPROVED",
  "IDLE",
  "PENDING",
  "REJECTED",
  "REVOKED",
]);
export type TelemetryConnectionStatus = z.infer<
  typeof telemetryConnectionStatusSchema
>;

export const telemetryDataPointTypeSchema = z.enum([
  "odometer",
  "location",
  "acceleration",
  "nextInspectionDate",
  "dashboardLight",
  "chargingPluggedIn",
  "batteryLevel",
  "batteryEnergy",
  "batteryCapacity",
  "batteryChargingRate",
  "batteryChargingTimeToComplete",
]);
export type TelemetryDataPointType = z.infer<
  typeof telemetryDataPointTypeSchema
>;

export const telemetryMileagePointSchema = z.object({
  vehicleUuid: z.uuid(),
  mileage: z.number(),
  date: z.iso.datetime(),
});
export type TelemetryMileagePoint = z.infer<typeof telemetryMileagePointSchema>;

export const telemetryDrivingEventTypeSchema = z.enum([
  "HARSH_ACCELERATION",
  "HARSH_BRAKING",
  "SHARP_TURNING",
]);
export type TelemetryDrivingEventType = z.infer<
  typeof telemetryDrivingEventTypeSchema
>;

export const highMobilityConnectionPlanSchema = z.enum(["PREMIUM", "LIGHT"]);
export type HighMobilityConnectionPlan = z.infer<
  typeof highMobilityConnectionPlanSchema
>;
